import { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import rehypeSanitize from 'rehype-sanitize';
import './SimpleMarkdown.css';

/**
 * Компактный markdown для коротких заметок (ДЗ в биллинге и т.п.).
 * Без ЕГЭ-препроцессоров, KaTeX и rehype-raw — обычный GFM + sanitize.
 */
function SimpleMarkdown({ text, className = '' }) {
  const content = String(text ?? '').trim();
  if (!content) return null;

  return (
    <div className={`simple-markdown ${className}`.trim()}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeSanitize]}
        components={{
          a({ href, children, ...props }) {
            return (
              <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                {...props}
              >
                {children}
              </a>
            );
          },
          img({ src, alt, ...props }) {
            return (
              <img
                src={src}
                alt={alt || ''}
                loading="lazy"
                className="simple-markdown-img"
                {...props}
              />
            );
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}

export default memo(SimpleMarkdown);
